import _ from 'lodash';
import Apis from '../../services/api';
import {
    default as actions,
    DISCOVERY_DEVICE,
    CONNECT_DEVICE,
    DISCONNECT_DEVICE,
    CONNECT_CURRENT,
    CONNECT_STATUS,
    CONNECT_DEVICE_MBLOCK_INFO,
    RESET_CONNECT_DEVICE,
    SWITCH_CONNECT_MODE,
    SET_IS_SHOW_ALL
} from './action';

import CONSTANT from '../../constant';

const defaultState = {
    // 连接类型（连接类型有区分当前扫描的连接类型作用, 防止当扫描结果未返回时切换扫描类型会使结果显示在新类型下的问题）
    type: CONSTANT.CONNECT_TYPE.SERIAL,
    // 已连接类型（已连接类型有记录当前连接类型状态）
    connectedType: '',
    // 连接信息
    connectionInfo: {},
    // 连接状态
    status: CONSTANT.CONNECT_STATUS.NOT_CONNECTED,
    // 当前连接(串口信息)
    current: '',
    // 连接设备 { id: '', name: '', address: '' , firmware: '' }
    devices: [],
    // 扫描状态
    scanStatus: CONSTANT.SCAN_STATUS.SCAN_READY,
    // 扫描的数据
    scanData: {},
    // 是否显示未筛选的数据
    isShowAll: false
};

const resetConnectDevice = (state, payload) => {
    let { devices } = state;
    if (!_.isEmpty(devices)) {
        if (payload.device && payload.isRemove) {
            devices.forEach(device => {
                if (device.name === payload.device.name) {
                    device.name = null;
                }
            });
            console.log({ devices });
            // devices.map((device) => {
            //     device.id = null;
            // });
        }
    }
    return state;
};

const disconnectState = (state, payload) => {
    if (!_.isEmpty(payload.device)) {
        _.remove(state.devices, (d) => {
            if (payload.isBroken) {
                return payload.device.address === d.address;
            }
            return payload.device.name === d.name;
        });
    }
    return Object.assign({}, state, {
        status: payload.status,
        connectedType: '',
        connectionInfo: {}
    });
};

const connectState = (state, payload) => {
    let { devices } = state;
    if (payload.device) {
        // const isExists = _.some(devices, { address: payload.device.address });
        // if (!isExists) {
        //     devices.push(payload.device);
        // }
        // for (let i = 0; i < devices.length; i++) {
        //     const device = devices[i];
        //     if (device.address === payload.device.address) {
        //         device.connected = true;
        //         devices[i] = Object.assign({}, device, payload.device);
        //     } else {
        //         devices[i].connected = false;
        //     }
        // }
        devices = [payload.device];
    } else if (payload.device === false) {
        devices = [];
    }
    return Object.assign({}, state, {
        ...payload,
        devices
    });
};

const statusState = (state, payload) => {
    return connectState(state, payload);
};

const mblockDeviceInfo = (state, payload) => {
    const { devices } = state;
    if (!_.isEmpty(devices)) {
        for (let i = 0; i < devices.length; i++) {
            const device = devices[i];
            if (device.address === payload.device.address) {
                devices[i] = Object.assign({}, device, payload.device);
                break;
            }
        }
    }
    return state;
};

const onDiscovery = (state, payload) => {
    const { type, scanStatus, scanData, isShowAll } = payload;

    let newState = Object.assign({}, state, payload);
    if (scanStatus !== CONSTANT.SCAN_STATUS.SCAN_SUCCESS) {
        return newState;
    }

    let data = [];
    if (scanData && scanData[type]) {
        data = scanData[type];
    }
    if (!isShowAll) {
        data = Apis.ConnectService.filterList(type, data);
    }
    data = Apis.ConnectService.sortBle(data);
    newState.scanData[type] = data;
    // 关联current

    // 判断current是否在扫描列表中,如果不在,则选取第0个
    if (newState.current) {
        let isInList = false;
        for (let i = 0; i < data.length; i++) {
            if (newState.current == data[i].comName) {
                isInList = true;
                break;
            }
        }
        if (!isInList) { // 不在列表中则重新选取
            if (data.length > 0) {
                newState.current = data[0].comName;
            } else {
                newState.current = '';
            }
        }
    } else { // 为空也重新选取current
        if (data.length > 0) {
            newState.current = data[0].comName;
        } else {
            newState.current = '';
        }
    }

    return newState;
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case RESET_CONNECT_DEVICE:
            return resetConnectDevice(state, action.payload);
        case CONNECT_CURRENT:
        case DISCOVERY_DEVICE: {
            // const type =  action.payload.type;
            // if(action.payload.scanStatus != CONSTANT.SCAN_STATUS.SCAN_SUCCESS){
            //     return Object.assign({}, state, action.payload);
            // }
            // if(state.scanData ) {
            //     const lastList = state.scanData[type];
            //     const currentList = action.payload.scanData[type];
            //     if(!lastList) {
            //         return Object.assign({}, state, action.payload);
            //     }
            //     if(lastList.length != currentList.length) { //如果数量不一致，则刷新
            //         return Object.assign({}, state, action.payload);
            //     }
            //     let dict ={};
            //     for(let i = 0; i < lastList.length; i++) {
            //         dict[lastList[i].comName] = 1;
            //     }
            //     for(let i = 0; i < currentList.length; i++) {
            //         if(!dict[currentList[i].comName]) { //包含不匹配的硬件列表
            //             return Object.assign({}, state, action.payload);
            //         }
            //     }
            // }

            // return Object.assign({}, state, action.payload);
            return onDiscovery(state, action.payload);

        }
        // return Object.assign({}, state);

        case CONNECT_DEVICE:
            return connectState(state, action.payload);
        case DISCONNECT_DEVICE:
            return disconnectState(state, action.payload);
        case CONNECT_STATUS:
            return statusState(state, action.payload);
        case CONNECT_DEVICE_MBLOCK_INFO:
            return mblockDeviceInfo(state, action.payload);
        case SWITCH_CONNECT_MODE:
        case SET_IS_SHOW_ALL:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};